import axios from "axios";
import {
  qureyFail,
  qureyRequest,
  qureySuccess,
} from "../slices/querySlices";
import { mainurl } from "./mainurl";


const baseurl = mainurl;

export const getQueryData = async (dispatch) => {
  try {
    dispatch(qureyRequest());
    const { data } = await axios.get(`${baseurl}/enquery/getenquery`);
    dispatch(qureySuccess(data));
  } catch (error) {
    dispatch(qureyFail(error?.response?.data?.message || "Unable to load queries"));
  }
};

